<app-page-meta pageTitle="finzy - Borrower Passbook"></app-page-meta>

<div class="container-fluid">
  <div class="row">
    <div class="col-xs-12">

      <div class="row finzy-row5">
        <p class="finzy-p-h">Keep track of all your money through your passbook!</p>

        <p class="finzy-txt-ps72"><span class="dark">Loan id: </span> #{{shortLoanId}} &nbsp;&nbsp;&nbsp;<span class="dark">Amount repaid: </span>₹
          {{ amountRepaid | decimal | number : fractionSize }} &nbsp;&nbsp;&nbsp;<span class="dark">Amount due: </span>₹
          {{ amountDue | decimal | number : fractionSize}}</p>

        <div class="row">
          <div class="col-xs-12">
            <p class="text-center note">Note: The outstanding amounts displayed are based on the EMI schedule and do not
              consider delays (if any). <br/>In case of a delay, you will be sent the outstanding due via an email.</p>
          </div>
        </div>

      </div>

      <div class="row finzy-row10gray" *ngIf="noPassbookdata">
        <p class="greydivp1"><i class="material-icons" style="font-size: 90px;color: #757575;">thumb_up</i></p>
        <p class="greydivp">You are all set!</p>
        <p class="greydivp">There is no passbook data to display</p>
      </div>


      <div class="row finzy-row10" *ngIf="!noPassbookdata">
        <mat-table #table [dataSource]="dataSource" matSort>

          <ng-container matColumnDef="timestamp">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Date</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.timestamp | dateFormat}}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef> Payment Type</mat-header-cell>
            <mat-cell *matCellDef="let element" style="text-transform: uppercase;"> {{element.type }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="amount">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Amount</mat-header-cell>
            <mat-cell *matCellDef="let element"> ₹ {{element.amount | decimal | number : fractionSize}}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="-">
            <mat-header-cell *matHeaderCellDef> Penalties</mat-header-cell>
            <mat-cell *matCellDef="let element"> --</mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>

        <mat-paginator #paginator [length]="5"
                       [pageSize]="5"
                       [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </div>
    </div>

  </div>
</div>
